module.exports = __webpack_public_path__ + "img/70f2.00a27392.jpg";